import React from "react";

export const ChartCard = ({ title, subtitle, action, children, className = "", testid }) => (
  <div
    data-testid={testid}
    className={`bg-white rounded-lg border border-slate-200 shadow-sm p-5 hover:shadow-md transition-shadow fade-up ${className}`}
  >
    <div className="flex items-start justify-between mb-4">
      <div>
        <h3 className="font-display text-base font-semibold text-slate-800">{title}</h3>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
    {children}
  </div>
);
